import {selectArr} from "../utils/utils";

export class HorizontalScroller {
    constructor() {
        let self = this;
        window.onload = function () {
            self.init();
        }
    }

    init() {
        selectArr('.wondersauce-horizontal-scroller').map(scroller => {
            //https://codepen.io/dec04/pen/DpGQJE
            const ssb = {
                containers: [],
                mouseX: 0,
                N: 0,
                asd: 0,
                sc: 0,
                sp: 0,
                to: 0,
                scrollbar: function (cont) {
                    if (!ssb.init()) return false;
                    let cont_clone = cont.cloneNode(false);
                    cont_clone.style.overflow = "hidden";
                    cont.parentNode.appendChild(cont_clone);
                    cont_clone.appendChild(cont);
                    ssb.containers[ssb.N++] = cont;
                    cont.sg = false;
                    cont.st = this.create_div('ssb_st', cont, cont_clone);
                    cont.sb = this.create_div('ssb_sb', cont, cont_clone);
                    cont.su = this.create_div('ssb_up', cont, cont_clone);
                    cont.sd = this.create_div('ssb_down', cont, cont_clone);
                    cont.ssb_onscroll = function () {
                        this.ratio = (this.offsetWidth - 2 * this.sw) / this.scrollWidth;
                        this.sb.style.left = Math.floor(this.sw + this.scrollLeft * this.ratio) + 'px';
                    }
                    cont.sw = 5;
                    cont.ssb_onscroll();
                    ssb.refresh();
                    cont.onscroll = cont.ssb_onscroll;
                    return cont;
                },
                init: function () {
                    function addEvent(o, e, f) {
                        if (window.addEventListener) {
                            o.addEventListener(e, f, false);
                            ssb.w3c = true;
                            return true;
                        }
                        if (window.attachEvent) return o.attachEvent('on' + e, f);
                        return false;
                    }

                    addEvent(window, 'resize', ssb.refresh);
                    return true;
                },
                create_div: function (c, cont, cont_clone) {
                    let o = document.createElement('div');
                    o.cont = cont;
                    o.className = c;
                    cont_clone.appendChild(o);
                    return o;
                },
                clear: function () {
                    clearTimeout(ssb.to);
                    ssb.sc = 0;
                    return false;
                },
                refresh: function () {
                    for (let i = 0, N = ssb.N; i < N; i++) {
                        let o = ssb.containers[i];
                        o.ssb_onscroll();
                        o.sb.style.height = o.st.style.height = o.su.style.height = o.sd.style.height = o.sw + 'px';
                        o.su.style.width = o.sd.style.width = o.sw + 'px';
                        o.sb.style.width = Math.ceil(Math.max(o.sw * .5, o.ratio * o.offsetWidth) + 1) + 'px';
                        let opacity = '1';
                        if (o.offsetWidth - 9 === Math.ceil(Math.max(o.sw * .5, o.ratio * o.offsetWidth) + 1)) {
                            opacity = '0';
                        }
                        o.sb.style.opacity = o.st.style.opacity = opacity;
                    }
                }
            }
            ssb.scrollbar(scroller)
        })
    }
}

